import BreatheLaunch from '.';
import { RouteType } from '@/lib/route';

const BreatheLaunchRoutes: RouteType = {
  path: '/breathe/:tenantId/:elearningId/launch',
  component: BreatheLaunch,
};

export interface BreatheLaunchParamType {
  tenantId: string;
  elearningId: string;
}

export default BreatheLaunchRoutes;
